import { useStore } from "vuex";

export default {
  name: 'ChatPanelTrigger',
  props: {
    actionId: {
      type: String
    }
  },
  setup(props) {
    const store = useStore();

    function initActionId() {
      store.dispatch("chatPanel/openChatAndHandleActionId", props.chatPanelActionId)
    }

    return {
      initActionId
    }
  }
}